<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <WdsAvatarLabel
    class="tw-my-3 tw-ml-4"
    :path="getAvatarPath(avatarPath, globalId)"
    :initials="initials"
    :text="name"
    :text-link="link"
  >
    <template #avatar-wrapper>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <ProfileInfoCard :global-id="globalId" placement="bottom" />
    </template>
    <template #subText>
      <span v-if="!recruiterManagesWorker && fee">
        <span class="tw-text-black">{{ fee }}</span>
        {{ $t('fee') }} ·
      </span>
      <span class="tw-text-black">{{ ownership ?? '-' }}</span>
      {{ $tc(':count ownership days', Number(ownership)) }}
    </template>
  </WdsAvatarLabel>
</template>

<script>
import { WdsAvatarLabel } from '@worksome/wds-components'
import ProfileInfoCard from '@/components/ProfileInfoCard.vue'
import { getAvatarPath } from '@/utils/avatar'

export default {
  name: 'DialogHeaderRecruiter',
  components: [WdsAvatarLabel, ProfileInfoCard],
  props: {
    globalId: { type: String, default: null },
    avatarPath: { type: String, default: null },
    initials: { type: String, default: null },
    name: { type: String, default: null },
    link: { type: String, default: null },
    fee: { type: String, default: null },
    ownership: { type: String, default: null },
    recruiterManagesWorker: { type: Boolean, default: false },
  },
  methods: {
    getAvatarPath,
  },
}
</script>
